// extracted by mini-css-extract-plugin
export default {"indent":"Privacy_indent__l8AYk","container":"Privacy_container__g+98E"};